import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { HeaderTheme } from 'utils/types/appTypes'
import Locations from 'views/components/locations'
import MembershipHeader from 'views/components/membershipHeader'
import { AppContext } from 'providers/context/App'
import { getUserInfo } from 'services/User'
import { MEMBERSHIP_EXISTING_USER_MAIN_ROUTE } from 'utils/constants/Helpers'
import { useSnackbar } from 'notistack'
import { GENERAL_ERROR_MESSAGE } from 'utils/constants/Messages'
import './membershipLocationSelection.scss'
import {
  MEMBERSHIP_DESCRIPTION,
  MEMBERSHIP_TITLE,
} from 'utils/constants/Membership'
import { captureError } from 'utils/sentry/sentry-utils'
import { FAILED_CHECK_MEMBER } from 'utils/sentry/sentry-messages'

const MembershipLocationSelection = () => {
  const { appMasterData } = useContext(AppContext)
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    checkIsMember().catch((e) => console.error(e))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const checkIsMember = async () => {
    try {
      if (appMasterData.isLoggedIn) {
        const response = await getUserInfo()
        if (response.is_member) {
          navigate(MEMBERSHIP_EXISTING_USER_MAIN_ROUTE)
        }
      }
    } catch (error) {
      captureError(FAILED_CHECK_MEMBER, {
        email: appMasterData.userInfo.email,
        error,
        functionName: checkIsMember.name,
      })
      enqueueSnackbar(GENERAL_ERROR_MESSAGE, { variant: 'error' })
    }
  }

  return (
    <>
      <MembershipHeader theme={HeaderTheme.GREEN} />
      <div className="location-header-container">
        <h2>{MEMBERSHIP_TITLE}</h2>
        <p>{MEMBERSHIP_DESCRIPTION}</p>
      </div>
      <div className="location-container">
        <Locations isMembership />
      </div>
    </>
  )
}

export default MembershipLocationSelection
